"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M16.9327 3.4815C17.0217 3.3925 17.1687 3.3765 17.2657 3.4565C17.7137 3.8235 17.9997 4.3795 17.9997 5.0045V12.0245C17.9997 13.1295 17.1047 14.0245 15.9997 14.0245H15.4997C15.2237 14.0245 14.9997 14.2495 14.9997 14.5265V16.4985C14.9997 16.9825 14.3807 17.1835 14.0957 16.7925L12.2927 14.3185C12.1057 14.1305 11.8507 14.0245 11.5857 14.0245H6.99269C6.76969 14.0245 6.65869 13.7555 6.81569 13.5975L16.9327 3.4815ZM13.9825 3C14.2055 3 14.3165 3.27 14.1595 3.427L3.70549 13.881C3.64149 13.944 3.54449 13.975 3.45749 13.95C2.61649 13.713 2.00049 12.939 2.00049 12.021V5C2.00049 3.896 2.89549 3 4.00049 3H13.9825Z",
    fill: "#727B7F"
  }));
};